// import { Link } from "react-router-dom";
import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import { styled } from "@mui/material/styles";
import {
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Link,
  List,
  ListItem,
  ListItemText,
  Select,
  SwipeableDrawer,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { Typography, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import Modal from "@mui/material/Modal";
import InquireForm from "../Form/inquire.component";

// const pages = ["ABOUT NEX", "SERVICES", "SHOWCASE", "CONTACT"];
const pages = [
  {
    slug: "about",
    name: "ABOUT NEX",
  },
  {
    slug: "services",
    name: "SERVICES",
  },
  {
    slug: "showcase",
    name: "SHOWCASE",
  },
  {
    slug: "contact",
    name: "CONTACT",
  },
];
const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "#EEF4FC",
  borderRadius: 4,
}));

export default function MainNav() {
  const theme = useTheme();
  const mediumScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const stickyRef = useRef(null);
  const [open, setOpen] = React.useState(false);
  const handleOpenInquire = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: mediumScreen ? "70vw" : '90vw',
    bgcolor: theme.palette.primary.main,
    // border: '2px solid #000',
    borderRadius: 2,
    boxShadow: 24,
    maxHeight:"90vh",
    overflowX:'hidden',
    overflowY:'scroll',
    // p: 4,
  };

  const formWrapper = {
    bgcolor: "#fff",
    borderRadius:2,
  };

  const handleScroll = () => {
    const currentOffset = window.scrollY;

    if (currentOffset > stickyRef.current.offsetTop) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }

    console.log("offset", currentOffset);
    console.log("menu offset", stickyRef.current.offsetTop);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  const onToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
    console.log("drawer condition", isDrawerOpen);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container>
            <Grid item md={5} style={{backgroundImage:`url(${process.env.PUBLIC_URL}"/img/bear-hand.png")`,backgroundSize:'cover',backgroundPosition:'center'}}>
              <Box p={3}>
                <Typography variant="h4" color={theme.palette.white.main}>
                  Have a project ?<br></br>We would love to help...
                </Typography>
              </Box>
            </Grid>
            <Grid item md={7}>
              <Box p={4} sx={formWrapper}>
                <InquireForm func={setOpen}></InquireForm>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Container>
        <StyledAppBar
          position="static"
          ref={stickyRef}
          className={isSticky ? "sticky" : ""}
        >
          <Container maxWidth="xl">
            <Toolbar disableGutters>
              {/* Logo */}
              <Box display={"flex"}>
                <img
                  src={process.env.PUBLIC_URL + "/img/logo-version2.png"}
                  style={{
                    width: mediumScreen ? 60 : 50,
                    paddingTop: 5,
                    paddingBottom: 5,
                  }}
                  alt="logo"
                ></img>
              </Box>

              {/* Mobile Menu Toggle */}
              <Box sx={{ display: { xs: "flex", md: "none" }, ml: "auto" }}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={onToggleDrawer}
                  color="primary"
                >
                  <MenuIcon />
                </IconButton>
              </Box>

              {/* Mobile Menu Toggle's Menu Item */}
              <Menu
                id="menu-appbar"
                // anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                // open={Boolean(anchorElNav)}
                // onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page.slug} onClick={() => alert("hello")}>
                    <Typography textAlign="center">
                      {page.name}+{page.slug}
                    </Typography>
                  </MenuItem>
                ))}
              </Menu>

              {/* Desktop Menu Items */}
              <Box
                sx={{
                  flexGrow: 1,
                  justifyContent: "center",
                  display: { xs: "none", md: "flex" },
                }}
              >
                {pages.map((page) => (
                  <Button
                    key={page}
                    style={{ fontWeight: "600" }}
                    sx={{ my: 2, mx: 1, color: "black", display: "block" }}
                  >
                    <Link href={"#" + page.slug}>{page.name}</Link>
                  </Button>
                ))}
              </Box>

              {/* INQUIRE Btn */}
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <Button variant="contained" onClick={handleOpenInquire}>
                  INQUIRE NOW
                </Button>
              </Box>
            </Toolbar>
          </Container>
        </StyledAppBar>
        <div
          style={{
            height: isSticky ? `${stickyRef.current?.clientHeight}px` : "0px",
          }}
        />
      </Container>

      <SwipeableDrawer
        anchor={"right"}
        open={isDrawerOpen}
        onClose={onToggleDrawer}
        PaperProps={{
          sx: {
            background:
              "radial-gradient(circle, rgb(7, 129, 160) 0%, rgb(2, 66, 94) 87%, rgb(2, 66, 94) 100%, rgb(2, 66, 94) 100%)",
            color: "white",
            padding: "2rem",
            minWidth: "40vw",
          },
        }}
      >
        {pages.map((page) => (
          <Button
            key={page}
            color={"white"}
            size="large"
            style={{ marginBottom: 20 }}
          >
            {page.name}
          </Button>
        ))}
        <Button variant="contained" onClick={handleOpenInquire}>INQUIRE NOW</Button>
      </SwipeableDrawer>
    </>
  );
}
